import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const CommandActionWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const LabelImages = styled.img`
    justify-content: center;
    text-align: center;
    align-self: center;
    max-height: 3rem;
    max-width: 48px;
`;

export const ItemCardTileWrapper = styled.div`
    margin: 0;
    padding-bottom: 0.5rem;
    height: 33rem;
    max-width: 22rem;
    min-width: 18rem;
    display: grid;
    grid-template-rows: min-content auto min-content;

    & .description-wrapper {
        overflow: hidden;
        max-height: available;
    }

    & .description-wrapper > p {
        margin: 0;
    }

    & .item-description {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        line-clamp: 4;
        word-break: break-all;
    }

    &:hover > .item-menu {
        background-color: inherit;
    }

    & .details-container {
        padding: 1rem 2rem 0 2rem;
        height: 15.6rem;
        background-color: inherit;
    }

    & .item-details-row-first {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        background-color: inherit;
    }

    & .item-details-row-second {
        height: 1.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        background-color: inherit;
    }

    & .item-details-row-third {
        height: 3rem;
        overflow: hidden;
        display: -webkit-box;
        background-color: inherit;
    }

    & .item-details-label-column {
        height: 3rem;
        width: 48px;
        padding-top: 0.5rem;
        padding-left: 15px;
        padding-right: 8px;
        margin-right: 8px;
    }

    & .item-title {
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
        height: 4rem;

        > div {
            display: inline-flex;

            > div {
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            > i {
                align-self: flex-end;
                font-size: 1.5rem;
                line-height: 1.4;
            }
        }
  }

    & .item-chevron {
        margin-left: 0.5rem;
    }

    & > .item-thumbnail {
        height: 12rem;
        border: 2px solid var(--background);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #FFFFFF;

        & > * {
        object-fit: cover;
        max-width: 100%;
        max-height: 100%;
        }
    }

    :hover > .item-thumbnail {
        border-color: var(--plain__enabled__fill__hovered);
    }

    @media only screen and (max-width: 768px) {
        max-width: 100%;
    }
`;

export const GridCustomButton = styled(Button)`
`;
